// services/userService.js
import axiosInstance from "./axiosInstance";

// Lấy thông tin user hiện tại
export const getCurrentUser = async () => {
    const res = await axiosInstance.get("/admin/me");
    return res.data;
};

// Cập nhật thông tin user
export const updateProfile = async (data) => {
    const res = await axiosInstance.put("/admin/me", data);
    return res.data;
};

// Đổi mật khẩu
export const changePassword = async (passwordData) => {
    const res = await axiosInstance.put("/admin/me/change-password", passwordData);
    return res.data;
};
